export default __webpack_public_path__ + "static/media/hht2_sitcom_12.185c6230.png";